export const filterRequests = (requests, query) => {
  return requests.filter((request) => {
    return (
      request?.id.includes(query) ||
      request?.kind.toLowerCase().includes(query.toLowerCase()) ||
      request?.status.toLowerCase().includes(query.toLowerCase())
    );
  });
};
